<template>
  <div class="product-video" :style="banner.styleArr" :id ="banner.title">
    <!-- 全屏视频背景 -->
    <div v-if="banner.videoUrl" class="banner-video-wrap">
      <video
          class="bg-video"
          autoplay
          muted
          loop
          playsinline
          :src="banner.videoUrl"
      ></video>
      <!-- 半透明遮罩，保证白色文字可读 -->
      <div class="video-mask"></div>
    </div>

    <!-- 文字按钮，浮在视频上层 -->
    <div class="banner-info need-padding">
      <span class="tips">{{ banner.title }}</span>
      <span class="title" v-html="banner.bigDescriptionHtml"></span>
      <div class="banner-discription-group">
        <span class="description" v-html="banner.descriptionHtml"></span>
      </div>
      <div class="link-group">
        <router-link v-if="banner.isRouter" :to="banner.buttonHref">
          <a class="primary-button">{{ banner.buttonName }}</a>
        </router-link>
        <a v-if="banner.isClick" class="next" @click="scrollTo('hero')" target="_blank" v-html="banner.buttonName"></a>
        <a v-else class="primary-button" :href="banner.buttonHref" target="_blank" v-html="banner.buttonName"></a>
        <a class="second-link" :href="banner.buttonLink" target="_blank">{{ banner.linkName }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import scrollTo from '@/utils/scrollTo'
export default {
  name: 'LaputaVideoBanner',
  props: ['banner'],
  methods: {scrollTo}
}
</script>

<style scoped>
.banner-discription-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0.8;
  margin: 24px 0 32px 0;
}
.link-group {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}
.next{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--laputa-card-background-white); /*  箭头强制白色，和标题文字统一 */
  animation: iconJump 2s ease-in-out infinite;
}
.next:hover {
  opacity: 0.75;
  transform: none;
  color: var(--laputa-black);
}
@keyframes iconJump {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(9px); /*跳动幅度，7‑11px*/
  }
  100% {
    transform: translateY(0);
  }
}
.product-video {
  position: relative;
  overflow: hidden;
  /* 区块高度，你可以自行修改，比如 100vh 占满屏幕 */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.product-video {
  position: relative;
  overflow: hidden;
  /* 区块高度，你可以自行修改，比如 100vh 占满屏幕 */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(180deg, #02162A 0%, #00001e 100%);
  padding: 0;
  height: fit-content;
  width: 100%;
}
.product-video .tips {
  color: var(--laputa-yellow);
  font-size: var(--laputa-fontsize-14);
}

.product-video span.title {
  font-size: var(--laputa-fontsize-56);
  color: var(--laputa-card-background-white);
  font-weight: bold;
  text-align: center;
  line-height: 60px;
  margin-top: 12px;
}

.banner-video-wrap {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.bg-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.24);
}

/* 内容提升层级，渲染在视频上方 */
.banner-info {
  position: relative;
  z-index: 2;
  text-align: center;
}
.banner-info span.description {
  font-size: var(--laputa-fontsize-16);
  color: var(--laputa-card-background-white);
  text-align: center;
}
/* 移动端关闭视频，降级回styleArr里面的静态背景 */
@media (max-width: 768px) {
  .bg-video {
    display: none;
  }
  .product-video {
    padding-top: 60px;
    min-height: 520px;
  }
}
a.primary-button {
  padding: 8px 26px;
  background: var(--laputa-card-background-white);
  color: var(--laputa-black);
  border-radius: 26px;
  transition: ease-in-out 0.3s;
  white-space: nowrap;
}

a.primary-button:hover {
  background: var(--laputa-black);
  color: var(--laputa-card-background-white);
}
a.second-link {
  color: var(--laputa-card-background-white);
  opacity: 0.6;
  font-size: 14px;
  margin-left: 12px;
  transition: ease-in-out 0.3s;
}

a.second-link:hover {
  opacity: 1;
}
.product-banner {
  background-image: linear-gradient(180deg, #02162A 0%, #00001e 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 94px 0 0 0;
  height: fit-content;
  /*移除两个大的div连接是的间隔*/
  margin: 40px 0;
  overflow: hidden;
  /*给内部绝对定位子元素做定位参照容器，子的 bottom/top 是相对于这个盒子*/
  position: relative;
  min-height: 800px;
  width: calc(100% - 48px);
  border-radius: 28px;
}
.banner-discription-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0.8;
  margin: 24px 0 32px 0;
}
.banner-pic-img {
  max-width: 968px;
  width: 100%;
  margin: auto;
}
.banner-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.link-group {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}
.banner-info span.description {
  font-size: var(--laputa-fontsize-16);
  color: var(--laputa-card-background-white);
  text-align: center;
}
.product-banner .tips {
  color: var(--laputa-yellow);
  font-size: var(--laputa-fontsize-14);
}

.product-banner span.title {
  font-size: var(--laputa-fontsize-56);
  color: var(--laputa-card-background-white);
  font-weight: bold;
  text-align: center;
  line-height: 60px;
  margin-top: 12px;
}

:deep(span.punctuation) {
  position: absolute;
}
a.primary-button {
  padding: 8px 26px;
  background: var(--laputa-card-background-white);
  color: var(--laputa-black);
  border-radius: 26px;
  transition: ease-in-out 0.3s;
  white-space: nowrap;
}

a.primary-button:hover {
  background: var(--laputa-black);
  color: var(--laputa-card-background-white);
}
a.second-link {
  color: var(--laputa-card-background-white);
  opacity: 0.6;
  font-size: 14px;
  margin-left: 12px;
  transition: ease-in-out 0.3s;
}

a.second-link:hover {
  opacity: 1;
}
.banner-pic {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  height: 400px;
  width: 100%;
  position: absolute;
  bottom: 100px;
}
.inline-word {
  word-break: keep-all;
  white-space: nowrap;
}
a {
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
}
span {
  user-select: none;
}
sup {
  font-size: 12px;
  background: var(--laputa-green);
  color: var(--laputa-card-background-white);
  padding: 4px;
  border-radius: 4px;
  margin-left: 6px;
  white-space: nowrap;
  position: absolute;
  top: -4px;
}
sup.hot {
  background: var(--laputa-red);
}

img {
  user-select: none;
  -webkit-user-drag: none;
}

@media screen and (max-width: 375px) {
  .first-stack {
    margin-bottom: 20px;
  }

  .left-Introduce {
    margin-bottom: 40px;
  }

  a.about-button {
    margin-top: 40px;
  }



  .product-banner {
    padding-top: 40px;
  }

  .banner-pic {
    margin-top: 0px;
    height: 150px;
  }

  a.linkbutton {
    margin-left: 8px;
  }

  .footer {
    margin-top: 20px;
  }

  .title-group .title {
    font-size: 35px;
    line-height: 1.2;
  }

  span.discription-text {
    font-size: 16px;
    line-height: 1.2;
  }

  a.about-button {
    padding: 0 24px;
  }

  .nav-center {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .first-stack {
    margin-bottom: 20px;
  }

  .left-Introduce {
    margin-bottom: 40px;
  }

  a.about-button {
    margin-top: 40px;
  }

  body .need-padding {
    width: 80%;
  }

  .first-stack {
    flex-direction: column;
    margin-top: 120px;
  }


  .footer {
    flex-direction: column;
    margin-top: 20px;
  }

  .footer .info {
    margin-bottom: 12px;
  }

  .show-menu .nav {
    background: var(--laputa-black);
  }

  .show-menu .nav-content {
    background: var(--laputa-black);
  }

  .nav-right .nav-item {
    display: none;
  }

  .nav-right .nav-menu {
    display: flex;
    color: var(--laputa-card-background-white);
    padding: 8px 0 8px 8px;
  }

  .product-banner span.title {
    font-size: 40px;
    line-height: 46px;
  }

  .show-menu .menu-list {
    height: 100%;
    opacity: 1;
  }

  .menu-list a.nav-item {
    padding: 8px 8px;
    font-size: 16px;
    border-bottom: 1px solid #ffffff53;
    width: 90%;
    margin-left: 0;
  }

  .show-menu .menu-list a.nav-item {
    padding: 12px 8px;
  }

  .banner-pic {
    height: 200px;
    bottom: 40px;
  }

  .product-banner {
    padding-top: 60px;
    min-height: 520px;
  }

  a.linkbutton {
    margin-left: 0px;
  }

  img.hello-img {
    display: none;
  }

  .banner-pic-img {
    width: 100vw;
  }

  .nav-center {
    display: none;
  }
}
@media screen and (max-width: 1200px) {
  .special-card {
    display: none;
  }

  .banner-pic {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img.hello-img {
    transform: translate(-60px, 55px) scale(1.5);
  }

}
</style>